import Vue from 'vue';

Vue.mixin({
	computed: {
		ada_hold_timer() {
			const date = new Date(null, null, null, null, null, this.hold_left);
			const minutes = date.getMinutes();
			const seconds = date.getSeconds();
			if (minutes) {
				return `Holding your items for the next ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
			} else if (seconds) {
				return 'Holding your items for less than a minute';
			} else {
				return 'Your shopping cart hold timer has ended, your items may be purchased by another customer';
			}
		},
	},

	methods: {
		ADAitemLabel: function (title, isbn, required) {
			let label = `Item name: ${title}, ISBN: ${this.ADAreadEachSymbol(isbn)}`;
			return required ? `${label}, this is a required item` : label;
		},

		ADAitemInCartLabel: function (title, isbn, required) {
			return this.ADAitemLabel(title, isbn, required).replace(/^(Item name)/, 'Item in cart');
		},

		ADAaddItemToCartLabel: function (type, price) {
			return `Add ${type} item for $${price} to cart`;
		},

		ADAgiftCertificateLabel: function (prefix, label) {
			label = label || 'Add a gift code or other payment code';
			return _.toString(label).replace(/^(Add|Paying with)/i, _.toString(prefix)).replace(/\?$/, '');
		},

		ADAcustomizeCertificateLabel: function (type, type_full, name, balance, hide_voucher_balance, inst_id) {
			let label = `Apply ${type_full} to this order` + ((!hide_voucher_balance && type === 'voucher') ? `, balance: $${balance}` : '');

			name = _.replace(name, /^\*+/, '').trim();
			label += name ? `, name ends with: ${this.ADAreadEachSymbol(name)}` : '';

			return label;
		},
	},
});
